// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1g3DL","content":"ManualTimeModal_content__256Y0"};